









































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { statisticDetailTimes } from '@/constants/type-helper';
import { namespace } from 'vuex-class';
import { AcgnFormTitle } from '@/components/';
import { openUrl } from '@/util';
import {
  AcgnTable,
} from '@acgn/herm/src/ui';
import AcgnPopFiledHistory from '../pop-field-history.vue';

const StatisticAction = namespace('desk/statistic').Action;
const StatisticGetter = namespace('desk/statistic').Getter;
import { DataTypesMixin } from '@/mixins';
const CommGetter = namespace('desk/comm').Getter;
@Component({
  components: {
    AcgnTable,
    AcgnFormTitle,
    AcgnPopFiledHistory
  },
  mixins: [ DataTypesMixin ]
})

/**
 * 任务情况-管理方
 */
export default class AcgnTaskDetail extends Vue {


  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: '' }) public exportCode: string; // 导出权限码

  @StatisticAction private getTaskCycleAdminDetail: any;
  @StatisticGetter private loadings: any; // loading
  @CommGetter private attributeData: any; // 公共类型
  private selectOpts: any = statisticDetailTimes;
  private selectType: number = 2;
  private isInit: boolean = false;
  private statusType: any = null;

  private statuss = [{
    id: 2,
    name: '审批通过'
  }];

  private tableConfig: any = {
    columns: [
      {
        label: '项目',
        prop: 'time_slot',
        width: 200
      },
      {
        label: '任务组数（话数）',
        prop: 'chnt'
      },
      {
        label: '任务数',
        prop: 'tnt'
      },
      {
        label: '环节数',
        prop: 'cnt'
      },
      {
        label: '件数',
        prop: 'num',
        render: (h: any, { row }: any) => (this as any).renderField(row)
      }
    ],
    data: []
  };
  private pageConfig: any = {}; // 分页数据
  private dataType: number = (this as any).comicId ? 2 : 1;
  private options: any = {
    apiType: 1,
    cycle_type: this.dataType > 0 ? 3 : this.selectType,
    project_id: (this as any).comicId
  };

  private renderField(row: any) {
    if (Array.isArray(row.num)) {
      const numValue = row.num[0];
      let numDiff = row.num[1];
      const classStyle = numDiff ? 'color--danger' : '';
      numDiff = numDiff ? numDiff : 0;
      return (
        <span class={classStyle}>{numValue + numDiff}{this.getUnitType(row.unit_type)}</span>
      );
    } else {
      return row.num;
    }
  }

  // table组件获取数据更新数据接口
  private async initSearh() {
    const _this = (this as any);
    const { tableConfig, pageConfig } = _this;
    const options = this.getSearchOptions();
    const { result } = await this.getTaskCycleAdminDetail(options);
    this.setListColumn(result.colnames, tableConfig);
    tableConfig.data = result.list;
  }

  private getSearchOptions() {
    return {
      type: this.selectType,
      project_id: this.comicId,
      status: this.statusType,
      order: this.dataType > 0 ? 1 : 2,
      data_type: this.dataType
    };
  }

  private setListColumn(colnames: any, config: any) {
    if (this.isInit) {
      return;
    }
    this.isInit = true;
    colnames.map((item: any) => {
      config.columns.push({
        label: item,
        prop: item
      });
    });
  }
  private getUnitType(type = 1) {
    const unitType = this.unitTypes.filter((item: any) => item.id === type);
    return unitType[0].name;
  }
  private get unitTypes() {
    return this.attributeData.unit_type || [];
  }
  private statusChange() {
    this.initSearh();
  }

  private selectChange() {
    this.options.cycle_type = this.dataType > 0 ? 3 : this.selectType; // 解决历史记录问题
    this.initSearh();
  }

  private exportExcel() {
    openUrl('/api/v1/workbench/taskcycleofadmin?export=1', this.getSearchOptions());
  }
}
